import { Gauge, Layers, Shuffle, Plug } from "lucide-react";

const pillars = [
  {
    Icon: Gauge,
    title: "Real-time Data",
    desc: "Millisecond events for ingest, processing and alerting. Built for systems that cannot wait",
  },
  {
    Icon: Layers,
    title: "High-performance Systems",
    desc: "Engineered for low latency, high throughput, and deterministic behavior under load",
  },
  {
    Icon: Shuffle,
    title: "Scalable Architecture",
    desc: "Horizontal and vertical scaling, container-native deployments and resilient distributed design",
  },
  {
    Icon: Plug,
    title: "Enterprise Integration",
    desc: "Designed to work with your existing stack across APIs, messaging, observability, and security",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how" className="relative py-24 md:py-32 bg-surface/40 border-y border-border">
      <div className="container">
        <div className="max-w-2xl mb-16">
          <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">How it works</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold leading-tight">
            Engineered for Production.
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            Every product is built on four core principles that define how we engineer software for demanding environments.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-border rounded-2xl overflow-hidden border border-border">
          {pillars.map((p, i) => (
            <div key={p.title} className="bg-background p-8 hover:bg-surface transition-colors">
              <div className="font-mono text-xs text-primary mb-6">0{i + 1}</div>
              <p.Icon className="h-7 w-7 text-primary mb-5" strokeWidth={1.75} />
              <h3 className="font-display text-xl font-semibold mb-2">{p.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
